import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import {
  billDueDate,
  billStatus,
  daysJsFormat,
  formatCurrency,
  keyBillStatus,
  renderBillStatus,
  statusControl,
  statusControlList,
} from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import dayjs from "../../../utils/dayjs";
import {
  setPropertiesPrestation,
  updateControlPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { renderAdress } from "../../container/Addresses/AddresseItem/AddresseHelpers";
import { t } from "i18next";
import { http } from "../../../engine/api/http";

export const BillCamtLinking = ({ defaultOpen }) => {
  const [modal, contextHolder] = Modal.useModal();

  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);
  const context = useContext(ModalContext);

  const { params, callback } = context;

  const { item, key } = params;

  let init = "";
  let control = "hidden";

  const inputs = inputsBillCamtLinking({ item });

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const onSubmitForm = async data => {
    try {
      const call = await http.post(`bills/${data.bill}/manual_camt_link`, {
        camt: item,
        comment_paiement: data.comment_paiement,
      });

      notification.success({
        message: t("camt.linkingSuccess"), // Liaison effectuée avec succès
      });

      close({ bill: call.data, key, billId: data.bill });
    } catch (e) {
      console.log(e);
    }
  };

  const close = p => {
    setOpen(false);
    context.closeModal(modalsByContext.BillCamtLinking, p);
  };

  const config = {
    key: item?.bankId + modalsByContext.BillCamtLinking,
    containerStyle: { minWidth: "9000px" },
    width: 800,
    title: t("camt.linkToInvoice"), // Associer à une facture
    open: open,
    cancelText: t("camt.close"), // Fermer
    okText: t("camt.confirm"), // Je confirme
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <p>
          {t("camt.paidBy")} : <b> {item.debitor}</b> <br />
          {t("camt.bankId")} : <b> {item.bankId}</b> <br />
          {t("camt.paidByAccount")} : <b> {item.debitorAccount}</b> <br />
          {t("camt.reference")} : <b> {item.ref}</b> <br />
          {t("camt.paidOn")} :{" "}
          <b> {dayjs(item.date).format(daysJsFormat.day)}</b> <br />
          {t("camt.amount")} : <b> {formatCurrency(item.amount)}</b>
        </p>
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        {t("camt.close")} {/* Fermer */}
      </Button>,
      <Button
        icon={<MdOutlineFreeCancellation size={20} />}
        type="primary"
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " " + t("camt.fieldsRequired"), // champs est nécessaire
            });
          }
        }}
      >
        {t("camt.confirmLink")} {/* Confirmer la liaison */}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const inputsBillCamtLinking = ({ item }) => {
  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("camt.internalInvoiceNumber"), // Numéro interne de la facture
          key: "status",
          name: "bill",
          required: true,
          type: "dynamic-select",
          endPoint: "bills/filter",
          method: "POST",
          body: { status: { $ne: "paid" } },
          itemsCallBack: bills => {},
          noSorting: true,
          itemCallback: bill => {
            return {
              key: bill._id,
              label: (
                <span>
                  {bill.bill_number} - {bill.institution.name}
                  {bill.status !== keyBillStatus.preparation
                    ? `- ${t("camt.payableOn")} ${billDueDate(bill)} -` // payable au
                    : " - "}
                  {formatCurrency(bill.amount)} - {renderBillStatus(bill, t)}
                </span>
              ),
              value: bill._id,
            };
          },
          col: 24,
        },
        {
          label: t("camt.paymentNote"), // Remarque sur le paiement
          name: "comment_paiement",
          type: "textarea",
          value: "",
          rows: 2,
          col: 24,
        },
      ],
    },
  ];
};
